import { connect } from '../../../../redux/connect';
import {
  fetchAttachmentsAction,
} from '../../../../redux/actions';
import React, { PureComponent } from 'react';

import IssuePreviewDetailsTabTitleSection from './components/IssuePreviewDetailsTabTitleSection';
import IssuePreviewDetailsTabGeneralSectionContainer from './components/IssuePreviewDetailsTabGeneralSection';
import IssuePreviewDetailsTabLinkedReferences from "./components/IssuePreviewDetailsTabLinkedReferences";
import IssuePreviewDetailsTabLinkedReferencesBy from "./components/IssuePreviewDetailsTabLinkedReferencesBy";
import IssuePreviewDetailsTabDistributionListSection from './components/IssuePreviewDetailsTabDistributionListSection';
import IssuePreviewDetailsTabOtherSection from './components/IssuePreviewDetailsTabOtherSection';
import IssuePreviewDetailsTabQuestionSection from './components/IssuePreviewDetailsTabQuestionSection';
import IssuePreviewDetailsTabAnswerSection from './components/IssuePreviewDetailsTabAnswerSection';
import IssuePreviewDetailsTabLinksSection from "./components/IssuePreviewDetailsTabLinksSection";
import { issueAttributesType } from '../../../../constants/proptype-validation';
import PropTypes from 'prop-types';
import featureFlags, { FEATURE_FLAGS } from "../../../../utils/featureFlags";

class IssuePreviewDetailsTab extends PureComponent {

  renderLinkedReferenceSection() {
    const { issue, container } = this.props;
    const linkToPcoFF = featureFlags.get(FEATURE_FLAGS.RFIS_LINK_TO_PCO);
    const referencedByFF = featureFlags.get(FEATURE_FLAGS.RFIS_REFERENCED_BY);

    return <React.Fragment>
      {(linkToPcoFF || referencedByFF) && <div className="IssuePreviewDetailsTab__separator" />}
      {linkToPcoFF && <IssuePreviewDetailsTabLinkedReferences issue={issue} container={container} />}
      {referencedByFF && <IssuePreviewDetailsTabLinkedReferencesBy issue={issue} container={container} renderTitle={!linkToPcoFF}/>}
    </React.Fragment>;
  }

  render() {
    const { issue, container } = this.props;

    return (
      <div className="IssuePreviewDetailsTab" data-testid="IssuePreviewDetailsTab">
        <IssuePreviewDetailsTabTitleSection issue={issue} />
        {issue.answer && <React.Fragment>
          <div className="IssuePreviewDetailsTab__separator" />
          <IssuePreviewDetailsTabAnswerSection issue={issue} container={container} />
        </React.Fragment>
        }
        <div className="IssuePreviewDetailsTab__separator" />
        <IssuePreviewDetailsTabGeneralSectionContainer issue={issue} container={container} />
        <div className="IssuePreviewDetailsTab__separator" />
        <IssuePreviewDetailsTabQuestionSection issue={issue} />
        <div className="IssuePreviewDetailsTab__separator" />
        <IssuePreviewDetailsTabLinksSection issue={issue} container={container} />
        {this.renderLinkedReferenceSection()}
        <div className="IssuePreviewDetailsTab__separator" />
        <IssuePreviewDetailsTabOtherSection issue={issue} container={container} />
        <div className="IssuePreviewDetailsTab__separator" />
        <IssuePreviewDetailsTabDistributionListSection issue={issue} container={container} />
      </div>
    );
  }
}

IssuePreviewDetailsTab.displayName = 'IssuePreviewDetailsTab';

IssuePreviewDetailsTab.propTypes = {
  issue: issueAttributesType,
  fetchAttachmentsAction: PropTypes.func.isRequired,
  container: PropTypes.object.isRequired,

};

const mapDispatchToProps = {
  fetchAttachmentsAction,
};

export default connect(null, mapDispatchToProps)(IssuePreviewDetailsTab);
